import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SPECIAL_BULLETS } from '../../../../../../texts';
import { SUB_SECTION_VIDEO } from '../../../../../../content';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { setCompactVideo } from '../../../../../../redux/actions';
import './CompactEntryButton.css';

class CompactEntryButton extends Component {
  constructor(props) {
    super(props);

    // bind
    this.handleClick = this.handleClick.bind(this);
  }

  // -------------------------------------------------------
  // Helpers
  // -------------------------------------------------------

  getIco() {
    return this.props.special ? 'cross' : this.props.data.ico;
  }

  getMapData() {
    const data = {
      color: '#f8f6e2',
      title: '',
    };
    if (this.props.special) {
      // note - not ideal condition- but sufficient for our current case
      data.title = this.isIntro() ? SPECIAL_BULLETS.START : SPECIAL_BULLETS.END;
    } else {
      const mapData = this.props.mapData.top.concat(this.props.mapData.bottom);
      for (let i = 0; i < mapData.length; i += 1) {
        if (
          mapData[i].hidden !== true &&
          mapData[i].hiliteId === this.props.data.hilite
        ) {
          data.color = mapData[i].color;
          data.title = mapData[i].label;
          break;
        }
      }
    }
    return data;
  }

  getBtnData() {
    const data = this.getMapData();
    data.ico = this.getIco();
    return data;
  }

  isIntro() {
    return this.props.section === 'INTRO';
  }

  // -------------------------------------------------------
  // Click
  // -------------------------------------------------------

  handleClick() {
    if (this.props.special) {
      this.props.setCompactVideo(
        this.isIntro() ? SUB_SECTION_VIDEO.INTRO : SUB_SECTION_VIDEO.OUTRO
      );
    } else {
      this.props.setCompactVideo(this.props.data.video);
    }
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const data = this.getBtnData();
    return (
      <button className="compact-entry-btn" onClick={this.handleClick}>
        <div
          className="ce-ico-wrap"
          style={{
            backgroundColor: data.color,
          }}
        >
          <img
            className="ce-ico"
            src={`${ASSETS_FOLDER}img/ico/bullet-line-${data.ico}.png`}
            alt=""
          />
        </div>
        <div>{data.title}</div>
      </button>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setCompactVideo: videoId => dispatch(setCompactVideo(videoId)),
});

export default connect(null, mapDispatchToProps)(CompactEntryButton);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/SceneCompact/CompactEntry/CompactEntryButton/CompactEntryButton.js